import { memo } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import config from 'Config';

import { getIsIncentiveEligibilityCheckComplete } from 'Store/incentives/selectors';
import { MODAL_LOGIN } from 'Store/modals/constants';
import { getIntroPriceDeeplinkDiscount, getIntroPriceDeeplinkTerm } from 'Store/user/selectors';

type Props = {
  title?: string;
  eligibilityCheckComplete?: boolean;
  introPriceTerm?: number;
  introPriceDiscount?: number;
};

const LoginTitle = (props: Props) => {
  const { formatMessage } = useIntl();
  const {
    eligibilityCheckComplete = false,
    introPriceDiscount = 0,
    introPriceTerm = 0,
    title,
  } = props;
  const billboardIntlKey = config.loginPage.billboard.i18nKey;

  let titleContent = title;

  if (eligibilityCheckComplete) {
    titleContent = formatMessage({ id: 'Incentives.mobileLoginHomePageMessage' });
  }

  if (introPriceTerm) {
    titleContent = formatMessage(
      {
        id: 'IntroPricing.discountedTermTitle',
      },
      {
        number: introPriceTerm,
        discount: introPriceDiscount,
        term: introPriceTerm,
      }
    );
  }

  return (
    <h1
      className="Px(16px)--s Typs(display-1-strong) Maw(100%) Ta(c) CenterAlign Fx($flx1)"
      id={MODAL_LOGIN}
    >
      {titleContent || formatMessage({ id: billboardIntlKey })}
    </h1>
  );
};

function mapStateToProps(state) {
  return {
    eligibilityCheckComplete: getIsIncentiveEligibilityCheckComplete(state),
    introPriceTerm: getIntroPriceDeeplinkTerm(state),
    introPriceDiscount: getIntroPriceDeeplinkDiscount(state),
  };
}

export default connect(mapStateToProps)(memo(LoginTitle));
